module.exports = __webpack_public_path__ + "static/media/forgot-password-left-image.b790be91.svg";